import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66a95824"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "radio",
    style: {"margin":"0"},
    id: $data.id,
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    "data-trigger": "manual",
    onChange: _cache[1] || (_cache[1] = (...args) => ($options.changeEvent && $options.changeEvent(...args)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (item) => {
      return (_openBlock(), _createElementBlock("label", {
        key: item.key
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: item.key,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selectValue) = $event))
        }, null, 8, _hoisted_2), [
          [_vModelRadio, $data.selectValue]
        ]),
        _createTextVNode(_toDisplayString(item.value), 1)
      ]))
    }), 128))
  ], 40, _hoisted_1))
}